import React, { useState } from 'react';
import { NavLink, Link } from "react-router-dom";
import NavBarMobile from './NavBarMobile';
import { Brand, Links, MyNav, NavBtns, NavContainer, NavLinks, DropDown, DropDownContant, NavToggles, } from './Style';



export default function NavBar() {

    const [active, setActive] = useState(false);
    const handlClick = () => setActive(!active);
    return (
        <>
            <MyNav id="navBar">
                <NavContainer>
                    <Brand ><h2>Educate</h2></Brand>
                    <NavLinks active={active}>
                        <Links>
                            <NavLink activeClassName="active" exact to="/" className=" navLink">Home</NavLink>
                            <NavLink activeClassName="active" to="/about" className="navLink" href="#">ABout</NavLink>
                            <NavLink activeClassName="active" to="/courses" className="navLink" href="#">Courses</NavLink>
                            <NavLink activeClassName="active" to="/blogs" className="navLink" href="#">Blog</NavLink>
                            <NavLink activeClassName="active" to="/contact" className="navLink" href="#">Contact</NavLink>
                            <DropDown>
                                <Link to='#'>Pages <i className="fas fa-sort-down"></i></Link>
                                <DropDownContant>
                                    <Link to="/singleCourse">Singal Course</Link>
                                    <Link to="/singleTeacher" >Singal Teacher</Link>
                                    <Link to="/singleBlog"  >Singal Blog</Link>
                                </DropDownContant>
                            </DropDown>
                        </Links>
                        <NavBtns>
                            <Link to="/signUp"> Sign Up</Link>
                            <Link to="/signIn"> Sign In</Link>
                        </NavBtns>
                    </NavLinks>
                    <NavToggles active={active} onClick={() => handlClick()} >
                        <span></span>
                        <span></span>
                        <span></span>
                    </NavToggles>
                </NavContainer>
            </MyNav>
            <NavBarMobile  active={active}/>
        </>
    )
}
